import React from 'react';
import PropTypes from 'prop-types'
import { isAuthorizedRole, isAuthenticated, login } from "./AppSecurity";
import { AccessDenied } from "../components/ErrorFragments";

export const RouteByRole = ({ roles, children, ...rest }) => (
  <>
    {isAuthenticated() ?
      isAuthorizedRole(roles) ? children : <AccessDenied />
      : login()
    }
  </>
)

export const AuthenticatedRoute = ({ children }) => (
  <>
    {isAuthenticated() ? children : login()}
  </>
)

AuthenticatedRoute.propTypes = {
  children: PropTypes.element.isRequired,
}

RouteByRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.element.isRequired,
}
